import { gql } from 'src/__generated__'

export default gql(`
  mutation refreshCanteen($canteenId: Int!) {
    refreshCanteen(canteenId: $canteenId)
  }
`)
